import {
  getTemplates,
  saveActionPlan,
  getActionPlans,
  updateActionPlan,
} from '@/service/actionPlan'

const actionPlan = {
  _id: undefined,
  thumbnail: '',
  image: '',
  title: '',
  description: '',
  metric: {},
  expiresAt: '',
  groupId: '',
  templateId: undefined,
  goal: undefined,
  tasks: [{ text: '', done: false }],
}

const initialState = () => {
  return {
    templates: undefined,
    actionPlan: actionPlan,
    list: [],
    pagination: undefined,
  }
}

let state = initialState()

const getters = {
  templates: state => state.templates,
  actionPlan: state => state.actionPlan,
  list: state => state.list,
  pagination: state => state.pagination,
}

const mutations = {
  setActionPlan(state, actionPlan) {
    state.actionPlan = JSON.parse(JSON.stringify(actionPlan))
  },
  setTemplates(state, templates) {
    state.templates = templates
  },
  setList(state, list = []) {
    state.list = list
  },
  setPagination(state, pagination = {}) {
    state.pagination = pagination
  },
}

const actions = {
  async loadTemplates({ commit }, metrics, exclude) {
    const templates = await getTemplates(metrics, exclude)
    commit('setTemplates', templates)
  },

  openPlanTemplate({ commit }, plan) {
    commit('setActionPlan', {
      _id: '',
      title: plan.title,
      description: plan.description,
      templateId: plan._id,
      image: plan.image,
      thumbnail: plan.thumbnail,
      tasks: plan.tasks || [],
      groupId: plan.groupId,
      metric: plan.metric,
      expiresAt: plan.expiresAt,
    })
  },

  openPlan({ commit }, plan) {
    commit('setActionPlan', {
      _id: plan._id,
      title: plan.title,
      description: plan.description,
      templateId: plan.templateId,
      image: plan.image,
      thumbnail: plan.thumbnail,
      tasks: plan.tasks || [],
      groupId: plan.groupId,
      metric: plan.metric,
      goal: plan.goal,
      expiresAt: plan.expiresAt,
    })
  },

  clearActionPlan({ commit }) {
    commit('setActionPlan', actionPlan)
  },

  async saveActionPlan({ state, commit }, actionPlan) {
    commit('setActionPlan', actionPlan)
    await saveActionPlan(state.actionPlan)
  },

  async loadList({ commit }, params = {}) {
    commit('setList', [])
    commit('setPagination', undefined)
    const { actionPlans, metadata } = await getActionPlans(params)
    commit('setList', actionPlans)
    commit('setPagination', metadata)
  },

  async updateActionPlan({ commit }, actionPlan) {
    commit('setActionPlan', actionPlan)
    await updateActionPlan(actionPlan)
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
